"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getDropdownMasterContractorCoalHauling = exports._getDropdownMasterContractorCoalMining = exports._getDropdownMasterContractorNotKideco = exports._getDropdownMasterContractorKideco = exports._getDropdownMasterContractorHauler = exports._getDropdownMasterContractorPit = exports._getDropdownMasterContractor = exports.deleteContractorData = exports.putContractorData = exports.postContractorData = exports.getEnum = exports._getMasterContractor = exports.getMasterContractor = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const getMasterContractor = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports.getMasterContractor = getMasterContractor;
const _getMasterContractor = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/master-data-contractor';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getMasterContractor = _getMasterContractor;
const getEnum = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/enum';
    const config = {
        params: {
            skip: 0, take: 100, filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'type', 'operator': 'contains', 'value': 'Contractor Type' }
                ]
            }
        },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [] };
    }
});
exports.getEnum = getEnum;
const postContractorData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    try {
        const { data } = yield axios_1.default.post(url, arg, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports.postContractorData = postContractorData;
const putContractorData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    try {
        const { data } = yield axios_1.default.put(url, arg, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports.putContractorData = putContractorData;
const deleteContractorData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/contractor/${arg.id}`;
    try {
        const { data } = yield axios_1.default.delete(url, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports.deleteContractorData = deleteContractorData;
const _getDropdownMasterContractor = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'is_active', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractor = _getDropdownMasterContractor;
const _getDropdownMasterContractorPit = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'is_active', 'operator': 'eq', 'value': true },
                    { 'field': 'coal_mining', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractorPit = _getDropdownMasterContractorPit;
const _getDropdownMasterContractorHauler = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'is_active', 'operator': 'eq', 'value': true },
                    { 'field': 'coal_hauling', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractorHauler = _getDropdownMasterContractorHauler;
const _getDropdownMasterContractorKideco = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'contractor_code', 'operator': 'contains', 'value': 'KJA' },
                    { 'field': 'is_active', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractorKideco = _getDropdownMasterContractorKideco;
const _getDropdownMasterContractorNotKideco = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'contractor_code', 'operator': 'doesnotcontain', 'value': 'KJA' },
                    { 'field': 'is_active', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractorNotKideco = _getDropdownMasterContractorNotKideco;
const _getDropdownMasterContractorCoalMining = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'is_active', 'operator': 'eq', 'value': true },
                    { 'field': 'coal_mining', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractorCoalMining = _getDropdownMasterContractorCoalMining;
const _getDropdownMasterContractorCoalHauling = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/contractor';
    const sort = [{ 'field': 'contractor_name', 'dir': 'asc' }];
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        },
        params: {
            skip: 0,
            take: 100,
            sort: JSON.stringify(sort),
            filter: {
                'logic': 'and',
                'filters': [
                    { 'field': 'is_active', 'operator': 'eq', 'value': true },
                    { 'field': 'coal_hauling', 'operator': 'eq', 'value': true }
                ]
            }
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getDropdownMasterContractorCoalHauling = _getDropdownMasterContractorCoalHauling;
